import * as React from 'react';

const ModalFooter = ({ children }: React.ComponentPropsWithoutRef<'footer'>) => {
    return <footer className="modal_footer">{children}</footer>;
};

export default ModalFooter;
